export const CSRF_TOKEN_EMPTY_EVENT_NAME = 'Csrf token is empty'
export const CSRF_TOKEN_EMPTY_FINGERPRINT = 'csrf-token-empty'
